import { createApiClientForEndpoint } from "../lib/apiClient";

//--- base of requests ---//
const api = createApiClientForEndpoint("general");

//////////////////////////////////////////////////
//-------------------- NAME --------------------//
//////////////////////////////////////////////////

//--- fetch names ---//
export const fetchNames = () => api.get(`/names/`);

//--- fetch name ---//
export const fetchName = ({ queryKey }) => {
  const nameId = queryKey[1];
  return api.get(`/name/${nameId}`);
};

//--- post name ---//
export const postName = (name) => api.post(`/name/`, name);

//--- put name ---//
export const putName = ({ nameId, ...name }) =>
  api.put(`/name/${nameId}`, name);

//--- delete name ---//

///////////////////////////////////////////////////
//-------------------- PHONE --------------------//
///////////////////////////////////////////////////

//--- fetch phones ---//
export const fetchPhones = () => api.get(`/phones/`);

//--- fetch phone ---//
export const fetchPhone = ({ queryKey }) => {
  const phoneId = queryKey[1];
  return api.get(`/phone/${phoneId}/`);
};

//--- post phone ---//
export const postPhone = (phone) => api.post(`/phone`, phone);

//--- put phone ---//
export const putPhone = ({ phoneId, ...phone }) => {
  api.put(`/phone/${phoneId}/`, phone);
};

//--- delete phone ---//

///////////////////////////////////////////////////
//-------------------- EMAIL --------------------//
///////////////////////////////////////////////////

//--- fetch emails ---//
export const fetchEmails = () => api.get(`/emails/`);

//--- fetch email ---//
export const fetchEmail = ({ queryKey }) => {
  const emailId = queryKey[1];
  return api.get(`/email${emailId}`);
};

//--- post email ---//
export const postEmail = (email) => api.post(`/email/`, email);

//--- put email ---//
export const putEmail = ({ emailId, ...email }) => {
  api.put(`/email/${emailId}/`, email);
};

//--- delete email ---//

////////////////////////////////////////////////////
//-------------------- COUNTY --------------------//
////////////////////////////////////////////////////
//--- fetch counties ---//
export const fetchCounties = () => api.get(`/counties/`);

//--- fetch county by id ---//
export const fetchCounty = ({ queryKey }) => {
  const countyId = queryKey[1];
  return api.get(`/county/${countyId}`);
};

//--- post county ---//
export const postCounty = (county) => api.post(`/county/`, county);

//--- put county ---//
export const putCounty = ({ countyId, ...county }) =>
  api.put(`/county/${countyId}`, county);

//--- delete county ---//

////////////////////////////////////////////////////////
//-------------------- REALESTATE --------------------//
////////////////////////////////////////////////////////
//--- fetch realestates ---//
export const fetchRealEstates = () => api.get(`/realestates/`);

//--- fetch realestate ---//
export const fetchRealEstate = ({ queryKey }) => {
  const realEstateId = queryKey[1];
  return api.get(`/realestate/${realEstateId}/`);
};

//--- post realestate ---//
export const postRealEstate = (realEstate) =>
  api.post(`/realestate/`, realEstate);

//--- put realestate ---//
export const putRealEstate = ({ realEstateId, ...realEstate }) => {
  api.put(`/realestate/${realEstateId}/`, realEstate);
};

//--- delete realestate ---//

//////////////////////////////////////////////////////
//-------------------- BUILDING --------------------//
//////////////////////////////////////////////////////

//--- fetch buildings ---//
export const fetchBuildings = () => api.get(`/buildings/`);

//--- fetch building ---//
export const fetchBuilding = ({ queryKey }) => {
  const buildingId = queryKey[1];
  return api.get(`/building/${buildingId}`);
};
//--- post building ---//
export const postBuilding = (building) => api.post(`/building/`, building);

//--- put building ---//
export const putBuilding = ({ buildingId, ...building }) => {
  api.put(`/building/${buildingId}`, building);
};

//--- delete building ---//

/////////////////////////////////////////////////////
//-------------------- ADDRESS --------------------//
/////////////////////////////////////////////////////
//--- fetch addresses ---//
export const fetchAddresses = () => api.get(`/addresses/`);

//--- fetch address by id ---//
//--- post address ---//
export const postAddress = (address) => api.post(`/address/`, address);

//--- put address ---//
export const putAddress = ({ addressId, ...address }) =>
  api.put(`/address/${addressId}/`, address);

//--- delete address ---//

////////////////////////////////////////////////////
//-------------------- OBJECT --------------------//
////////////////////////////////////////////////////
//--- fetch objects ---//
export const fetchObjects = () => api.get(`/objects/`);

//--- fetch object ---//
export const fetchObject = ({ queryKey }) => {
  const objectId = queryKey[1];
  return api.get(`/object/${objectId}`);
};

//--- post object ---//
export const postObject = (object) => api.post(`/object/`, object);

//--- put object ---//
export const putObject = ({ objectId, ...object }) => {
  api.put(`/object/${objectId}`, object);
};

//--- delete object ---//

/////////////////////////////////////////////////////
//-------------------- SUBJECT --------------------//
/////////////////////////////////////////////////////
//--- fetch subjects ---//
export const fetchSubjects = () => api.get(`/subjects/`);

//--- fetch subject ---//
export const fetchSubject = ({ queryKey }) => {
  const subjectId = queryKey[1];
  return api.get(`/subject/${subjectId}`);
};

//--- post subject ---//
export const postSubject = (subject) => api.post(`/subject/`, subject);

//--- put subject ---//
export const putSubject = ({ subjectId, ...subject }) => {
  api.put(`/subject/${subjectId}`, subject);
};

//--- delete subject ---//

/////////////////////////////////////////////////////////////
//-------------------- ACCOUNTING PLAN --------------------//
/////////////////////////////////////////////////////////////

//--- fetch accountingplans ---//
export const fetchAccountingPlans = () => api.get(`/accountingplans/`);

//--- fetch accountingplan ---//
export const fetchAccountingPlan = ({ queryKey }) => {
  const accountingPlanId = queryKey[1];
  return api.get(`/accountingplan/${accountingPlanId}`);
};

//--- post accountingplan ---//
export const postAccountingPlan = (accountingPlan) =>
  api.post(`/accountingplan/`, accountingPlan);

//--- put accountingplan ---//
export const putAccountingPlan = ({ accountingPlanId, ...accountingPlan }) => {
  api.put(`/accountingplan/${accountingPlanId}`, accountingPlan);
};

//--- delete accountingplan ---//
